export default __webpack_public_path__ + "static/media/style-angelusSlatestone.5b35ac84.jpg";